import { AfterViewInit, Component, inject, OnInit, ViewChild } from '@angular/core';
import {
  ChangePortalThemeFn,
  GetAllNotificationsFn,
  HeartbeatEvent,
  isInternalUser,
  PortalLoginUser, PortalThemeServiceEvent,
  SendDynabotMessageFn,
  SideMenuComponentFlatTreeNode,
  SideMenuComponentMenuType,
  WhitelabelServiceEvent
} from '@portal-workspace/grow-shared-library';
import { ActivationStart, NavigationEnd, Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import {
  navigationUrlForAggregators,
  navigationUrlForApplications,
  navigationUrlForAssetFinanceCalculator,
  navigationUrlForCompanies,
  navigationUrlForCustomers,
  navigationUrlForLgRebateCalculator,
  navigationUrlForLogin,
  navigationUrlForManualPayment,
  navigationUrlForNotifications,
  navigationUrlForPendingApprovals,
  navigationUrlForProfile,
  navigationUrlForRateCards,
  navigationUrlForSetMaintenance,
  navigationUrlForNewApplication,
  navigationUrlForUnsingedInvoices,
  navigationUrlForUnverifiedUsers,
  navigationUrlForUsers,
  navigationUrlForOauth,
  navigationUrlForNotificationsManagement,
  navigationUrlForFAQ,
  navigationUrlForAuditLogs,
  navigationUrlForDashboard,
  navigationUrlForBankStatementsAnalysis,
  navigationUrlForBankStatementsStatus,
  navigationUrlForAccreditation,
  navigationUrlForDocumentWorklist,
  navigationUrlForReporting,
  navigationUrlForCreditWorklist,
  navigationUrlForClientServicesWorklist,
  navigationUrlForAccreditationListing,
  navigationUrlForPromotion,
  navigationUrlForSettlementsWorklist,
  navigationUrlForRedbook,
  navigationUrlForPayments,
  navigationUrlForApplicationProcess,
  navigationUrlForPismoAccounts,
  navigationUrlForBusinessLoansCalculator,
  navigationUrlForCreditManagement, navigationUrlForOverdraftCalculator,
  navigationUrlForBusinessAndOverdraftBorrowingEstimator,
  navigationUrlForBsaSettings,
  navigationUrlForPendingApprovalTransactions,
  navigationUrlForOverdraftProduct,
  navigationUrlForWhitelabelSettings,
  navigationUrlForCronManagement,
  navigationUrlForSystemConnections,
  navigationUrlForConsentDashboard,
  navigationUrlForDynabotKnowledge,
} from '../../service/navigation-urls';
import {
  setBrowseHeightAsCssVariable,
  setupUntilDestroy,
  ToolbarComponentEvent
} from '@portal-workspace/grow-ui-library';
import { AuthService } from '../../service/auth.service';
import { UntilDestroy } from '@ngneat/until-destroy';
import { Observable, Subscription } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';
import { getUser } from '@portal-workspace/grow-ui-library';
import { NotificationService } from '../../service/notification.service';
import { environment } from '../../../environments/environment';
import { LayoutService } from '../../service/layout.service';
import { ErrorNotification2 } from '@portal-workspace/grow-ui-library';
import { SideMenuComponent } from '@portal-workspace/grow-ui-library';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { TopMenuComponent } from '@portal-workspace/grow-ui-library';
import { FlexModule } from '@angular/flex-layout/flex';
import { BreakpointService } from "@portal-workspace/grow-ui-library";
import { MatIconModule } from "@angular/material/icon";
import { NgxIndexedDBService } from 'ngx-indexed-db';
import { MatTooltipModule } from "@angular/material/tooltip";
import { WhitelabelService } from "../../service/whitelabel.service";
import { PortalThemeService } from "../../service/portal-theme.service";
import { HeartbeatService } from '../../service/heartbeat.service';
import { DynabotService } from '../../service/dynabot.service';
import { DynabotWidgetComponent } from '@portal-workspace/grow-ui-library';
import _ from 'lodash';

const APPLICATION_URL_PATTERN = /^\/s\/application\/(\d+)(?:[/?#]|$)/;

@UntilDestroy({ arrayName: 'subscriptions' })
@Component({
  templateUrl: './sidemenu.layout.html',
  styleUrls: ['./sidemenu.layout.scss'],
  providers: [
    { provide: LayoutService, useClass: LayoutService },
    DynabotService,
  ],
  standalone: true,
  imports: [FlexModule, TopMenuComponent, MatSidenavModule, SideMenuComponent, ErrorNotification2, RouterOutlet, MatIconModule, MatTooltipModule, DynabotWidgetComponent]
})
export class SidemenuLayout implements OnInit, AfterViewInit {
  mode: 'Mobile' | 'Desktop' | null = null;

  user: PortalLoginUser | null = null;
  impersonatedUser: PortalLoginUser | null = null;
  showMinimizeImpersonation = true;

  unreadNotificationsCountObservable!: Observable<number>;
  whitelevelServiceEventObserver!: Observable<WhitelabelServiceEvent>;

  changePortalThemeFn!: ChangePortalThemeFn;
  portalThemeObservable!: Observable<PortalThemeServiceEvent>;
  heartbeatObservable!: Observable<HeartbeatEvent>;
  getAllNotificationsFn!: GetAllNotificationsFn;
  subscriptions: Subscription[] = [];
  sideNavGap = 100;

  gitTagOrVersion = environment.gitTag ?? environment.gitHash;

  menuItemId: any = '';

  breakpointService!: BreakpointService;
  portalThemeService!: PortalThemeService;
  whitelabelService!: WhitelabelService;
  heartbeatService!: HeartbeatService;

  @ViewChild('sidenav') matSidenav!: MatSidenav;

  footerAlignment: 'flex-start' | 'center' | 'flex-end' = 'center'; // Default alignment
  footerPosition: number = 2; // Default position (1, 2, or 3)

  dynabotEnabled = false;
  dynabotApplicationId: number | null = null;
  sendDynabotMessageFn!: SendDynabotMessageFn;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private notificationService: NotificationService,
    private dbService: NgxIndexedDBService,
    private authService: AuthService,
    private dynabotService: DynabotService) {
    this.breakpointService = inject(BreakpointService);
    this.whitelabelService = inject(WhitelabelService);
    this.portalThemeService = inject(PortalThemeService);
    this.heartbeatService = inject(HeartbeatService);
    this.getAllNotificationsFn = this.notificationService.getAllNotifications;
  }

  async onSidemenuEvents($event: SideMenuComponentFlatTreeNode) {
    switch ($event.treeNode.type) {
      case 'lg-rebate-calculator':
        await this.router.navigate(navigationUrlForLgRebateCalculator());
        this.closeSideNav();
        break;
      case 'asset-finance-calculator':
        await this.router.navigate(navigationUrlForAssetFinanceCalculator());
        this.closeSideNav();
        break;
      case 'business-loans-calculator':
        await this.router.navigate(navigationUrlForBusinessLoansCalculator());
        this.closeSideNav();
        break;
      case 'business-overdraft-calculator':
        await this.router.navigate(navigationUrlForOverdraftCalculator());
        this.closeSideNav();
        break;

      case 'applications':
        await this.router.navigate(navigationUrlForApplications());
        this.closeSideNav();
        break;
      case 'customers':
        await this.router.navigate(navigationUrlForCustomers());
        this.closeSideNav();
        break;
      case 'unsigned-invoices':
        await this.router.navigate(navigationUrlForUnsingedInvoices());
        this.closeSideNav();
        break;
      case 'manual-payment':
        await this.router.navigate(navigationUrlForManualPayment());
        this.closeSideNav();
        break;
      case 'users':
        await this.router.navigate(navigationUrlForUsers());
        this.closeSideNav();
        break;
      case 'pending-approvals':
        await this.router.navigate(navigationUrlForPendingApprovals());
        this.closeSideNav();
        break;
      case 'aggregators':
        await this.router.navigate(navigationUrlForAggregators());
        this.closeSideNav();
        break;
      case 'companies':
        await this.router.navigate(navigationUrlForCompanies());
        this.closeSideNav();
        break;
      case 'rate-cards':
        await this.router.navigate(navigationUrlForRateCards());
        this.closeSideNav();
        break;
      case 'set-maintenance':
        await this.router.navigate(navigationUrlForSetMaintenance());
        this.closeSideNav();
        break;
      case 'transactions':
        await this.router.navigate(navigationUrlForPayments());
        this.closeSideNav();
        break;
      case 'pending-approval-transactions':
        await this.router.navigate(navigationUrlForPendingApprovalTransactions());
        this.closeSideNav();
        break;
      case 'oauth':
        await this.router.navigate(navigationUrlForOauth());
        this.closeSideNav();
        break;
      case 'promotion':
        await this.router.navigate(navigationUrlForPromotion());
        this.closeSideNav();
        break;
      case 'unverified-users':
        await this.router.navigate(navigationUrlForUnverifiedUsers());
        this.closeSideNav();
        break;
      case 'new-application':
        await this.router.navigate(navigationUrlForNewApplication());
        this.closeSideNav();
        break;
      case 'notifications-management':
        await this.router.navigate(navigationUrlForNotificationsManagement());
        this.closeSideNav();
        break;
      case 'audit-logs':
        await this.router.navigate(navigationUrlForAuditLogs());
        this.closeSideNav();
        break;
      case 'dashboard':
        await this.router.navigate(navigationUrlForDashboard());
        this.closeSideNav();
        break;
      case 'overdraft-product':
        await this.router.navigate(navigationUrlForOverdraftProduct());
        this.closeSideNav();
        break;
      case 'pismo-accounts':
        await this.router.navigate(navigationUrlForPismoAccounts());
        this.closeSideNav();
        break;
      case 'bank-statements-analysis':
        await this.router.navigate(navigationUrlForBankStatementsAnalysis());
        this.closeSideNav();
        break;
      case 'bank-statements-status':
        await this.router.navigate(navigationUrlForBankStatementsStatus());
        this.closeSideNav();
        break;
      case 'accreditation':
        await this.router.navigate(navigationUrlForAccreditation());
        this.closeSideNav();
        break;
      case 'document-worklist':
        await this.router.navigate(navigationUrlForDocumentWorklist());
        this.closeSideNav();
        break;
      case 'reporting':
        await this.router.navigate(navigationUrlForReporting());
        this.closeSideNav();
        break;
      case 'credit-worklist':
        await this.router.navigate(navigationUrlForCreditWorklist());
        this.closeSideNav();
        break;
      case 'client-services-worklist':
        await this.router.navigate(navigationUrlForClientServicesWorklist());
        this.closeSideNav();
        break;
      case 'settlements-worklist':
        await this.router.navigate(navigationUrlForSettlementsWorklist());
        this.closeSideNav();
        break;
      case 'redbook':
        await this.router.navigate(navigationUrlForRedbook());
        this.closeSideNav();
        break;
      case 'business-and-overdraft-borrowing-estimator':
        await this.router.navigate(navigationUrlForBusinessAndOverdraftBorrowingEstimator());
        this.closeSideNav();
        break;
      case 'bsa-settings':
        await this.router.navigate(navigationUrlForBsaSettings());
        this.closeSideNav();
        break;
      case 'credit-management':
        await this.router.navigate(navigationUrlForCreditManagement());
        this.closeSideNav();
        break;
      case 'cron-management':
        await this.router.navigate(navigationUrlForCronManagement());
        this.closeSideNav();
        break;
      case 'whitelabel-settings':
        await this.router.navigate(navigationUrlForWhitelabelSettings());
        break;
      case 'system-connections':
        await this.router.navigate(navigationUrlForSystemConnections());
        this.closeSideNav();
        break;
      case 'consent-dashboard':
        await this.router.navigate(navigationUrlForConsentDashboard());
        this.closeSideNav();
        break;
      case 'dynabot-knowledge':
        await this.router.navigate(navigationUrlForDynabotKnowledge());
        this.closeSideNav();
        break;
    }
  }

  async onSidemenuEvents2($event: SideMenuComponentMenuType) {
    switch ($event) {
      case 'profile':
        await this.router.navigate(navigationUrlForProfile());
        this.closeSideNav();
        break;
      case 'contact-us':
        try {
          window.open(`${environment.contactUsUrl}`, '_blank');
          this.closeSideNav();
        } catch (err) {
          console.log(`error opening window to ${environment.contactUsUrl}`);
        }
        break;
      case 'faq':
        await this.router.navigate(navigationUrlForFAQ())
        this.closeSideNav();
        break;
      case 'product-guide':
        try {
          window.open(`${environment.brokerProductGuideUrl}`, '_blank');
          this.closeSideNav();
        } catch (err) {
          console.log(`error opening window to ${environment.brokerProductGuideUrl}`);
        }
        break;
      case 'notifications':
        await this.router.navigate(navigationUrlForNotifications());
        this.closeSideNav();
        break;
      case 'accreditation-listing':
        await this.router.navigate(navigationUrlForAccreditationListing());
        this.closeSideNav();
        break;
      case 'aml':
        await this.router.navigate(navigationUrlForApplicationProcess());
        this.closeSideNav();
        break;
    }
  }

  async onTopMenuEvent($event: ToolbarComponentEvent) {
    switch ($event.type) {
      case 'logout':
        this.authService.logout().pipe(
          finalize(async () => {
            this.dbService.count("applications").subscribe((peopleCount) => {
              if (peopleCount) {
                this.dbService.clear("applications").subscribe((successDeleted) => {
                  console.log('success? ', successDeleted);
                });
              }
            });
            await this.router.navigate(navigationUrlForLogin());
          })
        ).subscribe();
        break;
    }
  }

  ngOnInit() {
    setupUntilDestroy(this);
    this.unreadNotificationsCountObservable = this.notificationService.unreadNotificationsCount.asObservable();
    this.whitelevelServiceEventObserver = this.whitelabelService.subject.asObservable();
    this.changePortalThemeFn = this.portalThemeService.changePortalThemeFn;
    this.portalThemeObservable = this.portalThemeService.subject.asObservable();
    this.heartbeatObservable = this.heartbeatService.subject.asObservable();
    this.getAllNotificationsFn = this.notificationService.getAllNotifications;

    setTimeout(() => {
      this.sideNavGap = (document.querySelector('.top-menu-component') as HTMLElement)?.offsetHeight ?? 0;
    });
    this.user = getUser();
    this.menuItemId = (this.route.snapshot.data as any).menuItemId;
    const sub = this.router.events.pipe(
      tap(r => {
        if (r instanceof ActivationStart) {
          this.menuItemId = (r.snapshot.data as any).menuItemId;
        }
      })
    ).subscribe();
    if (!_.isEmpty(localStorage.getItem("isImpersonate"))) {
      this.impersonatedUser = this.user;
    } else {
      this.impersonatedUser = null;
    }
    this.setupDynabot();
  }

  private setupDynabot() {
    if (!isInternalUser(this.user) || this.impersonatedUser) {
      return;
    }
    this.sendDynabotMessageFn = this.dynabotService.sendDynabotMessageFn;
    this.dynabotApplicationId = this.applicationIdFromUrl(this.router.url);
    this.subscriptions.push(this.dynabotService.isDynabotEnabled().subscribe(enabled => this.dynabotEnabled = enabled));
    this.subscriptions.push(this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.dynabotApplicationId = this.applicationIdFromUrl(event.urlAfterRedirects);
      }
    }));
  }

  private applicationIdFromUrl(url: string): number | null {
    const match = APPLICATION_URL_PATTERN.exec(url);
    return match ? Number(match[1]) : null;
  }

  ngAfterViewInit() {
    setBrowseHeightAsCssVariable();
    this.subscriptions.push(this.breakpointService.deviceSubject.subscribe(r => {
      setTimeout(async () => {
        this.mode = r;
        if (r === 'Mobile') {
          await this.matSidenav.close();
        } else {
          await this.matSidenav.open();
        }
      })
    }));
  }

  closeSideNav() {
    if (this.mode === 'Mobile') {
      this.matSidenav.close();
    }
  }

  exitImpersonation() {
    this.authService.exitImpersonation();
  }

  onHoverImpersonation(e: any) {
  }

  changeFooterPosition(increment: number) {
    this.footerPosition += increment;
    this.updateFooterAlignment();
  }

  private updateFooterAlignment() {
    switch (this.footerPosition) {
      case 1:
        this.footerAlignment = 'flex-start'; // Align left
        break;
      case 2:
        this.footerAlignment = 'center'; // Center align
        break;
      case 3:
        this.footerAlignment = 'flex-end'; // Align right
        break;
    }
  }
}
